import { Moon, Sun, Computer } from "./clearsense-ui/icons";

const THEMES = [
  {
    title: "Light",
    key: "light",
    icon: Sun,
  },
  {
    title: "Dark",
    key: "dark",
    icon: Moon,
  },
  {
    title: "System",
    key: "system",
    icon: Computer,
  },
];

export { THEMES };
